import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import {
  getTriggerOrderQuoteRequest,
  executeTriggerOrderQuoteRequest,
  cancelTriggerOrderRequest,
} from '../../request/triggerOrdersRequest';
import {
  GET_TRIGGER_ORDER_QUOTE,
  EXECUTE_TRIGGER_ORDER_QUOTE,
  CANCEL_TRIGGER_ORDER,
} from '../actions/triggerOrders/triggerOrdersActionConstants';
import {
  getTriggerOrderQuoteSuccess,
  getTriggerOrderQuoteError,
  executeTriggerOrderQuoteSuccess,
  executeTriggerOrderQuoteError,
  cancelTriggerOrderSuccess,
  cancelTriggerOrderError,
} from '../actions/triggerOrders/triggerOrdersActions';
import { rejectErrorCodeHelper } from '../../util/helpers/rejectErrorCodeHelper';

function* getTriggerOrderQuote({ payload }) {
  try {
    const { data } = yield call(getTriggerOrderQuoteRequest, payload);
    yield put(getTriggerOrderQuoteSuccess(data));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(getTriggerOrderQuoteError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, errorMessage);
    }
  }
}

function* executeTriggerOrderQuote({ payload }) {
  try {
    const { data } = yield call(executeTriggerOrderQuoteRequest, payload);
    yield put(executeTriggerOrderQuoteSuccess(data));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(executeTriggerOrderQuoteError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, errorMessage);
    }
  }
}

function* cancelTriggerOrder({ payload }) {
  try {
    const { data } = yield call(cancelTriggerOrderRequest, payload);
    yield put(cancelTriggerOrderSuccess(data));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(cancelTriggerOrderError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, errorMessage);
    }
  }
}

export default function* triggerOrdersSaga() {
  yield all([
    takeLatest(GET_TRIGGER_ORDER_QUOTE, getTriggerOrderQuote),
    takeLatest(EXECUTE_TRIGGER_ORDER_QUOTE, executeTriggerOrderQuote),
    takeLatest(CANCEL_TRIGGER_ORDER, cancelTriggerOrder),
  ]);
}
